const thConfiguration = {
  name: 'Funding Societies',
  email: 'info@fundingsocieties.com',
  country_code: 'TH',
  country_name: 'Thailand',
  currency: 'THB - Thailand Baht',
  currency_code: 'THB',
  currency_symbol: '฿',
  enableLoyaltyProgram: false,
  encryption_key: 'FS-TH',
  header_logo_classname_prefix: 'funding-societies',
  header_vertical_logo_classname_prefix: 'funding-societies-vertical',
  header_vertical_logo_path: '/assets/img/header/logo-fs-vertical.svg',
  header: {
    completeAccountActivation: {
      show: true
    },
  },
  format: {
    date: 'y-MM-dd',
    date_time: 'y-MM-dd HH:mm:ss',
    activity_date_time: 'MMM dd y HH:mm',
    decimal: '1.2-2',
    decimal_separator: '.',
    thousands_separator: ',',
    locale: 'en'
  },
  borrower_referral_email: {
    show: true,
    email: 'refer@fundingsocieties.com'
  },
  institution_id: 1,
  language: 'th',
  supportedLanguages: ['en', 'th'],
  mobileAppUrl: {
    investor: {
      googlePlay: 'https://play.google.com/store/apps/details?id=com.fundingsocieties.fundingsocieties',
      appStore: 'https://apps.apple.com/th/app/funding-societies/id1108023092'
    },
  },
  meta: {
    image: '/assets/img/icon/logo.png',
    og_type: 'information',
    twitter_card: 'summary_large_image',
    twitter_site: '@FundSocieties'
  },
  google_tag_manager_id: 'GTM-MG6WPLG',
  intercom: {
    enable: true
  },
  portfolio: {
    showBorrowerIdentity: {
      company: true,
      name: false
    },
    tableColumnDisplay: {
      gst: false,
      withholdingTax: false
    },
    showTaxField: true,
    columnNumber: 13
  },
  wallet: {
    show: false,
  },
  investor: {
    overview: {
      bonus: false,
    },
    settings: {
      hasInvestorProfiles: true,
    },
  },
  sendgrid_template: {
    investor_twoFa_email_template_id: '8b5450f6-b7c0-4def-b9a0-981133882e8f',
    borrower_twoFa_email_template_id: '8b5450f6-b7c0-4def-b9a0-981133882e8f',
    borrower_email_template_id: '',
    investor_email_template_id: ''
  },
  referralLink: {
    borrower: window.location.origin + '/sign-up-borrower?referral=',
    investor: window.location.origin + '/sign-up-investor?referral='
  },
  browseLoan: {
    borrowerName: true,
    discussionForum: true,
    discussionForumLink: 'https://crowdfundtalks.com/category/2/other-topics',
    showOptOut: true,
    redirectToPayment: true,
    powerOfAttorney: false,
    riskDisclosureStatement: true,
    riskDisclosureStatementChecked: false,
    suitabilityAssessmentTest: true,
    suitabilityAssessmentTestChecked: false,
    personalParticularsDisclaimer: false,
    personalParticularsDisclaimerChecked: false,
    referSme: false,
    investmentInformation: true,
    investmentHistory: {
      showOutstandingDetail: false
    },
    blog: 'https://blog.fundingsocieties.com?utm_source=mainsitesg&utm_medium=investpage',
    fundingProgress: {
      show: true,
      successfulLimit: 80
    },
    crowdfundingTimeLeft: {
      exact: true,
      showInSuccessLoan: true
    },
    retailInvestorInvestingLimit: {
      enable: true
    },
    payment: {
      expiryTime: 30 //in minutes
    }
  },
  referral: {
    vip: false
  },
  image_base_url: 'assets/img/TH',
  phone_prefix: '+65',
  help: {
    general: {
      en: 'https://help.fundingsocieties.com'
    },
    borrower: {
      en: 'https://help.fundingsocieties.com/borrowers'
    },
    investor: {
      en: 'https://help.fundingsocieties.com/investors'
    },
    show: {
      publicPage: false,
      loggedInPage: false //For submenu when user already log in
    }
  },
  story: 'https://blog.fundingsocieties.com/our-story?utm_source=mainsitesg&utm_medium=footer',
  blog: 'https://blog.fundingsocieties.co.th/?utm_source=mainsite&utm_medium=footer',
  learningCenter: 'https://blog.fundingsocieties.com/learning-center?utm_source=mainsite&utm_medium=organic',
  minimizingRiskArticle: 'https://blog.fundingsocieties.com/investments/how-diversification-can-help-to-minimise-risks-in-p2p-lending?utm_source=mainsitesg&utm_medium=investpage&utm_campaign=diversify',
  maximizingInvestmentArticle: 'https://blog.fundingsocieties.com/investments/how-maximise-your-p2p-investments?utm_source=mainsitesg&utm_medium=investpage&utm_campaign=reinvest',
  mediapress: 'https://fundingsocieties.com/press/2020',
  inTheNews: 'https://fundingsocieties.com/in-the-news/2020',
  facebook: 'https://www.facebook.com/fundingsocietiesthailand',
  linkedin: '',
  twitter: '',
  instagram: 'https://www.instagram.com/fundingsocietiesth/',
  line: 'https://lin.ee/RuL3cg1',
  // Navigation configurations
  referProgram: true,
  digisign: {
    loan: false,
  },
  marketingBanner: {
    showCovidCampaignBanner: true,
  },
  menu: {
    feedback: false
  },
  showPartner: true,
  showInvestorExposureBanner: false,
  showInvestorAccreditedDeclarationBanner: false,
  showPrivacyNoticeInvoiceFinancing: false,
  showPrivacyNoticeMalay: false,
  showAddBankAccount: false,
  showTaxInvoice: false,
  showPrivacyNotice: true,
  zoho_leads_owner: null,
  zoho_leads_owner_id: null,
  zoho_leads_source: 'Website Homepage Form',
  wootricToken: 'NPS-8c7383f1',
  boltLinkBorrowPage: 'https://fsbolt.com?utm_source=website&utm_medium=landing_page_borrow',
  applyBoltBorrowPage: 'https://fsbolt.com/web/business-information?utm_source=website&utm_medium=landing_page_borrow',
  showDisclosureNotice: false,
  infoEmail: 'investor@fundingsocieties.co.th',
  enable2Fa: true,
  enable2FaLogin: true,
  learnMoreAALink: 'https://help.fundingsocieties.com/investors/auto-invest-error-messages-explained',
  enableWootric: false,
  showLegalPopup: true,
  passportExpiredMonthLimit: 6,
  careerBambooHRLink: 'https://www.linkedin.com/company/funding-societies-modalku/jobs/',
  enableRestructuredLoan: true,
  restructuredLoanLink: 'http://help.fundingsocieties.com/en/articles/3277106-understanding-restructuring',
  websiteTermsAndConditionPdf: '/assets/legal/FundingSocieties-WebsiteTermsAndConditions.pdf',
  subDistrictDetailEnabled: true,
  navigation: {
    loginDropDown: false,
    exposeSignUpMenu: true,
    blog: {
      show: true,
      link: 'https://blog.fundingsocieties.co.th'
    },
    getFunding: {
      show: true,
      link: 'https://fundingsocieties.co.th/?lang=en#application-form'
    }
  },
  dateRestrictions: {
    passportExpiry: 6,
    myInfoPassExpiry: 6
  },
  modalPromoBanner: false,
  showFacilityLoan: false,
  showICNumberText: true,
  statements: {
    excludedEventTypes: ['DEPOSIT', 'WITHDRAWAL'],
  },
  statistic: {
    showDefaultRate: true,
    mediaPressButton: {
      show: false
    }
  },
  autoInvestment: {
    enableAutoInvestment: false,
    borrowerExposure: {
      show: true
    },
    borrowerExposureWarning: {
      minimumValue: 30,
      show: true
    },
    enableInvestIslamicOnlyToggle: false,
  },
  signUp: {
    allowedOTpChannel: ['sms'],
    automatedPrefilHowDidYouFindUs: {
      enable: false,
      referral: false
    }
  },
  twoFa: {
    verify: true
  },
  memberSetting: {
    agreement: {
      manualInjection: {
        show: false,
        link: ''
      }
    }
  },
  reverification: {
    show: true,
    riskDisclosure: true,
    suitabilityAssessment: false,
    hideLoanCards: false,
    eKYC: false,
  },
  withdrawal: {
    allowDecimalInput: true
  },
  footer: {
    appDownloadButton: {
      show: false
    },
    menu: {
      media: {
        show: false,
      },
      whoWeAre: {
        show: true,
        subMenu: {
          ourStory: false,
          statistics: false,
          careers: false,
          help: false,
        }
      }
    }
  },
  analytics: {
    SearchGuru: {
      investorSignUpSuccess: false
    }
  },
  showCreateNewLoanButton: true,
  showDashboardAgreementModal: true,
  showFSCInvestment: false,
  liveCaptureDocsForEKYC: null,
  enableEsignPerInvestment: false,
};

export default thConfiguration;
